import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.less']
})

export class TooltipComponent implements OnInit {
  @Input() position: string;
  @Input() tip: string;
  public info: boolean = false;

  constructor() { }

  public ngOnInit(): void { }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/tooltip/tooltip.component.ts